var map = {
	"./autoParts.js": [
		962,
		10
	],
	"./catering.js": [
		963,
		2
	],
	"./electron.js": [
		964,
		9
	],
	"./equipments.js": [
		965,
		8
	],
	"./estate.js": [
		966,
		5
	],
	"./financialInsurance.js": [
		967,
		7
	],
	"./fmcg.js": [
		968,
		1
	],
	"./household.js": [
		969,
		0
	],
	"./largeGroup.js": [
		970,
		4
	],
	"./medical.js": [
		971,
		3
	],
	"./newEnergy.js": [
		972,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 679;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/solution lazy ^\.\/.*\.js$
// module id = 679
// module chunks = 12